module.exports = __webpack_public_path__ + "media/assets/logo_basic-cca8ff81d7955c131e4da838d1f61dc0.jpg";